import React from 'react';

interface SuccessSectionProps {
  donationAmount: number;
  onMakeAnotherDonation: () => void;
}

const SuccessSection: React.FC<SuccessSectionProps> = ({ donationAmount, onMakeAnotherDonation }) => {
  return (
    <section id="success-message" className="success-section" style={{backgroundColor: '#dcfce7'}}>
      <div className="container">
        <div className="success-message" style={{maxWidth: '600px'}}>
          <div className="success-icon">✓</div>
          <h2 style={{fontSize: '2rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '20px'}}>
            Thank You for Your Donation!
          </h2>
          <p style={{color: '#6b7280', marginBottom: '30px', fontSize: '1.1rem'}}>
            Your donation of R{donationAmount} will help save lives and fight malaria. 
            You should receive a confirmation email shortly.
          </p>
          <div style={{display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center'}}>
            <button
              onClick={onMakeAnotherDonation}
              className="btn btn-primary"
            >
              Make Another Donation
            </button>
            <p style={{fontSize: '0.9rem', color: '#6b7280', textAlign: 'center'}}>
              Your generosity helps us continue our mission to eliminate malaria worldwide.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessSection;
